module.exports = __webpack_public_path__ + "img/1465378794.cd7d56f6.jpg";